import React, { useEffect, useState } from 'react'
import { ReactComponent as SearchIcon } from '../../images/public/header/search.svg'
const Searchbar2 = ({Values,setFilter}) => {
    const [search,setSearch] =useState('');
    function filterFunction(){
      if(search === ""){
        setFilter(Values);
      }
      else{
        const filted = Values.filter((obj)=>{
          return Object.values(obj)
          .join(" ").toLowerCase()
          .includes(search.toLowerCase());
        })
        setFilter(filted);
      }
    }
    useEffect(()=>{
      filterFunction()
    },[])
    useEffect(()=>{
      filterFunction()
    },[search,Values])
  return (
    <div className='forms_searchbar_container'>
      <input 
      value={search}
      onChange={(e) => {
        setSearch(e.target.value)
      }}
      placeholder="Search"
      />
      <div className='forms_searchbar_icon'>
        <SearchIcon />
      </div>
    </div>
  )
}

export default Searchbar2
